import { QueryResult } from '@apollo/client';
import { LoadingButton } from '@atlaskit/button';
import { HelperMessage } from '@atlaskit/form';
import { abgGraphqlClient as graphqlClient } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { GetUpdatePaymentMethodLinkPane } from '@css-xp/base/common-sidebars';
import React from 'react';
import { fetchPaymentMethodUpdateLink } from './queries/fetch-payment-method-update-link';

interface Props {
  transactionAccountId?: string | undefined;
}

export const PaymentMethodComponent = ({ transactionAccountId }: Props) => {
  const [paymentMethodLink, setPaymentMethodLink] = React.useState<
    Partial<QueryResult<generatedTypesNew.FetchPaymentMethodUpdateLinkQuery>>
  >({ loading: true });
  const [generatedLink, setGeneratedLink] = React.useState<string | null | undefined>('');

  React.useEffect(() => {
    (async () => {
      try {
        const transactionAccountPaymentMethods = await graphqlClient().query({
          query: fetchPaymentMethodUpdateLink,
          variables: { id: transactionAccountId },
          fetchPolicy: 'no-cache',
        });

        setPaymentMethodLink(transactionAccountPaymentMethods);
      } catch {
        setPaymentMethodLink({ loading: false });
      }
    })();
  }, []);

  const generatePaymentMethodLink = () => {
    setGeneratedLink(paymentMethodLink?.data?.transactionAccount?.updatePaymentMethodLink);
  };

  return (
    <div className="create-txa-container payment">
      <h2>Payment methods</h2>
      <HelperMessage>Transaction accounts require at least one payment method</HelperMessage>
      <div className="payment-link-section">
        <div className="link-copy-section">
          <HelperMessage>
            <b>Share payment method link with the billing admin so they can add payment details.</b>
          </HelperMessage>
          <LoadingButton isLoading={paymentMethodLink.loading} onClick={generatePaymentMethodLink} appearance="primary">
            Get update payment link
          </LoadingButton>
        </div>
        {generatedLink && generatedLink?.length > 0 && (
          <div className="update-link-section">
            <GetUpdatePaymentMethodLinkPane title={''} subTitle="" updatePaymentMethodLink={generatedLink} />
          </div>
        )}
      </div>
    </div>
  );
};
